/**
 * Authentication data models
 */

export interface AuthData {
    email: string;
    aasToken: string;
    authToken?: string;
    gsfId?: string;
    deviceCheckInConsistencyToken?: string;
    deviceConfigToken?: string;
    dfeCookie?: string;
    locale: string;
}

export interface AuthHeaders {
    [key: string]: string;
}

export interface SessionData extends AuthData {
    // Extended session data if needed
}